<template>
	<component
		:is="link ? AtomLink : 'div'"
		:class="[
			'flex flex-col items-center gap-8 shadow-lg rounded py-8 px-10 text-center bg-white',
			link ? 'hover:scale-105 transition-transform' : '',
		]"
		v-bind="link?.to"
		data-testid="molecule-card"
	>
		<div
			class="rounded-full w-24 h-24 bg-brand-50 flex items-center justify-center"
		>
			<AtomFontAwesome
				class="w-9 h-9 text-purple-500"
				:icon="icon"
			/>
		</div>
		<div class="flex flex-col gap-3">
			<AtomTitle
				tag="h3"
				size="md"
			>
				{{ title }}
			</AtomTitle>
			<p class="text-paragraph-size-sm text-blue-800">
				{{ description }}
			</p>
		</div>
		<span
			v-if="link"
			class="text-functional-size-sm underline underline-offset-4 text-purple-800 hover:text-purple-400"
		>
			{{ link.text }}
		</span>
	</component>
</template>

<script lang="ts" setup>
import type { FontAwesomeIconType } from '#base/app/plugins/fontawesome';
import type { LinkType } from '#base/core/types/LinkType';

type Props = {
	title: string;
	description: string;
	icon: FontAwesomeIconType;
	link?: LinkType;
};

defineProps<Props>();

const AtomLink = resolveComponent('AtomLink');
</script>
